/**
 * @generated SignedSource<<b9ea929c7ab7c075bed623095bf805b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef";
};
export type assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef$key = {
  readonly " $data"?: assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "assignee_issueFieldAssigneeInlineEditFull_AssigneeInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "93c1d9e2338da6a23190803216172e69";

export default node;
